import React from 'react'
import style from './style.css'

export default class Spinner extends React.Component
{
    render()
    {
        return (
            <div class={`${style.skfoldingcube}`}>
                <div class={`${style.skcube1} ${style.skcube}`}></div>
                <div class={`${style.skcube2} ${style.skcube}`}></div>
                <div class={`${style.skcube4} ${style.skcube}`}></div>
                <div class={`${style.skcube3} ${style.skcube}`}></div>
            </div>
     );
    }
}



// WEBPACK FOOTER //
// src/component/Spinner/FoldingCube/index.js